import { useEffect } from "react";
import { useRouterState } from "@tanstack/react-router";
import { initAnalytics, trackPageview, maybeStartRecording } from "@/lib/analytics";

/**
 * Initializes PostHog after hydration (idle-scheduled) and tracks SPA
 * pageviews on every TanStack Router navigation.
 *
 * Mount once in RootInner. Admin paths are excluded.
 *
 * Session-Recording wird beim Eintritt in einen Conversion-Pfad nachgezogen,
 * damit Recording auch dann läuft, wenn der Nutzer nicht initial auf
 * /kontakt, /tools oder /leistungen/* landet.
 */
export function PostHogTracker() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (pathname.startsWith("/admin")) return;
    trackPageview(window.location.href);
    maybeStartRecording(pathname);
  }, [pathname]);

  return null;
}
